/**
 * @file cars.api.js
 * @module CarsAPI
 * @description HTTP API wrapper for cars/vehicles related endpoints. Methods return Axios promises.
 */

import { axiosInstance } from "./axios"
export const CarsAPI = {
    /**
     * Upload a file (e.g., insurance picture) using multipart/form-data.
     * @param {FormData|Object} body - FormData containing file(s).
     * @param {string} token - Optional auth token.
     * @returns {Promise} Axios promise resolving to upload result.
     */
    uploadFIle: async (body, token = "") => {
        return await axiosInstance(token).post(`/picture/upload/insurance`, body, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    /**
     * Get cars options (lightweight select list).
     * @param {string} token - Optional auth token.
     * @returns {Promise} Axios promise resolving to options.
     */
    getCarsOptions: (token = "") => {
        return axiosInstance(token).get(`/cars-options`);
    },

    /**
     * Retrieve cars with pagination and optional query.
     * @param {number} limit
     * @param {number} page
     * @param {string} [query=""]
     * @param {string} token
     * @returns {Promise} Axios promise resolving to cars list.
     */
    getCars: (limit, page, query = "", token = "") => {
        return axiosInstance(token).get(`/cars?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
    },

    /**
     * Get a car by id.
     * @param {string} carId
     * @param {string} token
     * @returns {Promise} Axios promise resolving to car data.
     */
    getCarById: (carId, token = "") => {
        return axiosInstance(token).get(`/cars/${carId}`);
    },

    /**
     * Get a car by slug.
     * @param {string} slug
     * @param {string} token
     * @returns {Promise} Axios promise resolving to car data.
     */
    getCarBySlug: (slug, token = "") => {
        return axiosInstance(token).get(`/cars/slugs/${slug}`);
    },

    /**
     * Update a car by id.
     * @param {string} carId
     * @param {Object} car - Updated car payload.
     * @param {string} token
     * @returns {Promise} Axios promise resolving to updated car.
     */
    updateCarById: (carId, car, token = "") => {
        return axiosInstance(token).patch(`/cars/${carId}`, car);
    },
}